export const CHECKLIST_TYPE = {
  REGULAR: 0,
  AANAME: 1,
  QUALITY: 2,
  INFO: 3,
  EXTRA_PART: 4,
  EXTENSION: 5,
  TEST_DRIVE: 6,
};
